export default __webpack_public_path__ + "static/media/element_spec_67.590c5eb2.webp";